// extracted by mini-css-extract-plugin
module.exports = {"container":"container--SpaceMembers-Spaces-routes__vzlNZ","search":"search--SpaceMembers-Spaces-routes__2TFS5"};